import { Box, Typography, Divider } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function InfoPage({ dark, border, barBg, isMobile }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>

      {/* ── Header ── */}
      <Box sx={{ height: 52, display: "flex", alignItems: "center", px: 2, gap: 1, borderBottom: `1px solid ${border}`, bgcolor: barBg, flexShrink: 0 }}>
        <InfoOutlinedIcon sx={{ fontSize: 20, color: "text.secondary", flexShrink: 0 }} />
        <Typography sx={{ fontSize: "0.85rem", fontWeight: 700 }}>Info & Disclaimer</Typography>
      </Box>

      {/* ── Content ── */}
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: 3, py: 3, bgcolor: "background.default" }}>

        {/* About */}
        <Typography sx={{ fontSize: "1rem", fontWeight: 700, mb: 1.5, color: "text.primary" }}>
          About the App
        </Typography>
        <Typography sx={{ fontSize: "0.9rem", color: "text.secondary", lineHeight: 1.7, mb: 3 }}>
          MAIN // DANFORTH is an independent and unofficial application that aggregates useful information for the Main Street and Danforth Avenue community.
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {/* Disclaimer */}
        <Typography sx={{ fontSize: "1rem", fontWeight: 700, mb: 1.5, color: "text.primary" }}>
          Disclaimer
        </Typography>
        <Typography sx={{ fontSize: "0.9rem", color: "text.secondary", lineHeight: 1.7 }}>
          The information in this application comes from publicly available sources. The data may be delayed, inaccurate, or incomplete. Never use the data in this application to make important decisions. MAIN // DANFORTH is not affiliated with (or endorsed by) Toronto Police Service, Toronto Fire Service, TTC, or Metrolinx.
        </Typography>

      </Box>

      {/* ── Footer ── */}
      <Box sx={{ height: 52, bgcolor: barBg, borderTop: `1px solid ${border}`, px: 2, display: "flex", alignItems: "center", flexShrink: 0 }}>
        <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "0.65rem" }}>
          MAIN // DANFORTH · Independent & Unofficial
        </Typography>
      </Box>
    </Box>
  );
}
